import React, {useEffect} from 'react'
import {Route, Redirect, useHistory} from 'react-router-dom'
import {connect, useDispatch} from 'react-redux'
import AdminLayout from 'layouts/Admin'
import Swal from 'sweetalert2'
import { fetchSettings } from 'redux/Settings/SettingsAction'
const  AdminRoute = ({component:Component, authenticated, admin, authChecked, loading, userDetails,updateUserProfile, ...rest}) => {
    
    const history = useHistory();
    const dispatch = useDispatch();

    const isValidUSE164 = (s) => /^\+1[2-9]\d{2}[2-9]\d{6}$/.test(s);
    
    const isValidUSNumber = (input) => {
        const d = (input || "").replace(/\D/g, "");
    
        const e164 =
            d.length === 10 ? `+1${d}` :
            (d.length === 11 && d.startsWith("1") ? `+${d}` : null);
        return e164 ? isValidUSE164(e164) : false;
    };

    useEffect(() => {
            
        if (typeof userDetails.handle != "undefined" && !updateUserProfile.loading) {


            const phoneNumber = updateUserProfile.userprofile?.[0]?.phoneNumber ? updateUserProfile.userprofile?.[0]?.phoneNumber : userDetails.phoneNumber;
            
            if (!isValidUSNumber(phoneNumber)) {
                
                setTimeout(() => {
                    Swal.fire({
                        title: 'Phone Number',
                        text: userDetails.phoneNumber ? "Not valid. Please re-enter your phone number." : "Enter a valid 10-digit U.S. phone number.",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#5e72e4',
                        confirmButtonText: 'Go to My Profile',
                        cancelButtonText: 'Close',
                        allowOutsideClick: true
                    }).then((result) => {
                        if(result.isConfirmed){
                            if (history.location.pathname != "/client/my-profile") {
                                history.push("/client/my-profile")
                            }
                        }
                    });
                }, 5000);

            }
            

        }

    }, [updateUserProfile])

    useEffect(() => {
        dispatch(fetchSettings())
    }, [])

    return (
        <Route {...rest}
            render = {(props) => {
                // Show loading while checking authentication
                if (!authChecked || loading) {
                    Swal.fire({
                        title: 'Loading...',
                        text: 'Please wait while loading',
                        allowOutsideClick: false,
                        showConfirmButton: false,
                        didOpen: () => {
                            Swal.showLoading();
                        }
                    });
                    return null;
                } else {
                    // Always close any existing Swal when auth check is complete
                    if (Swal.isVisible()) {
                        Swal.close();
                    }
                }

                if (authenticated === true ){
                    if (admin === true ){

                        return <AdminLayout><Component {...props}/></AdminLayout>
                    } else {

                        return <Redirect to = "/client/dashboard"/>
                    }
                } else {
                    return <Redirect to = "/auth/login"/>
                }
            }
            }
        />
)}
const mapStateToProps = (state) => ({
    authenticated: state.loginAuth.authenticated,
    admin: state.loginAuth.admin,
    authChecked: state.loginAuth.authChecked,
    loading: state.loginAuth.loading,
    userDetails : state.loginAuth.userDetails,
    updateUserProfile: state.updateUserProfile
})

export default connect(mapStateToProps)(AdminRoute)
